import React from 'react'
import ReactTable  from "react-table";
import axios from 'axios'
import {getToken} from '../../storage'
import {API_BASE_URL} from '../../constants'
import DateFormat from '../../utils/dateformat'
import {Link } from 'react-router-dom'



class Pretns extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    document.title = "Debit Notes List"
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        if(row.original.is_generalnote) {
          this.props.history.push('/general_debit_notes/edit/'+row.original.serial)
        }
        else {
          this.props.history.push('/debit_notes/edit/'+row.original.serial)
        }
      },
      style: {
        cursor:'pointer'
      }
    }
  }

  fetchData(state, instance) {
    this.setState({ loading: true });
    let apiurl = "/list_pretns/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
    }
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.pretns,
        pages: res.data.pages,
        loading: false
      });
    });
  }

  getSerial(row) {

    if(row.original.is_generalnote) {
      return <span>{row.original.serial} <span className="label label-info">General Debit Note</span></span>
    }
    else {
      return <span>{row.original.serial} <span className="label label-warning">Invoice Debit Note</span></span>
    }
  }

  getAmount(row) {
    if(row.original.is_generalnote) {
      return row.original.amount
    }
    else {
      return row.original.totalPrice
    }
  }

  getTax(row) {
    if(row.original.is_generalnote) {
      return "NA"
    }
    else {
      return row.original.totalTax
    }
  }

  getTotal(row){
    if(row.original.is_generalnote) {
      return "NA"
    }
    else {
      return row.original.total
    }
  }

  supplierNameFormat(row) {

    if(row.original.supplier !== null) {
      const supplier = row.original.supplier
      return <div>{supplier.name} {supplier.city}</div>
    }
    else {
      return null
    }
  }

  render() {

    const { data, pages, loading } = this.state;
    const columns = [
      {Header:'ID', accessor:'serial', Cell:(row)=>(<div>{this.getSerial(row)}</div>) },
      {Header:'Supplier', accessor: 'supplier.name',sortable:false, Cell:(row)=>{return this.supplierNameFormat(row)} },
      {Header:'Date', accessor: 'date', sortable:false, Cell:(row)=>(<DateFormat date={row.original.date}/>)},
      {Header:'Amount',  accessor:'summary_totalPrice',sortable:true, Cell:(row)=>(<div className="text-right">{row.original.totalPrice}</div>) },
      {Header:'Tax',  accessor:'summary_totalTax', sortable:true, Cell:(row)=>(<div className="text-right">{this.getTax(row)}</div>) },
      {Header:'Total',  accessor:'summary_total', sortable:true, Cell:(row)=>(<div className="text-right">{this.getTotal(row)}</div>) },
    ]
    const defaultSort=[{id: "serial", desc: true}]
    return <div><section className="medium">
      <ul className="list-inline">
        <li><Link to="/debit_notes/create" className="btn btn-primary">Create New Debit Note (Invoice)</Link></li>
        <li><Link to="/general_debit_notes/create" className="btn btn-primary">Create New Debit Note (Just Amount)</Link></li>
      </ul>
    </section>
    <div className="row">
      <div className="col-sm-12">
        <div className="table-responsive">
          <ReactTable defaultSorted={defaultSort}
            getTrProps={this.handleTrclick}
            noDataText="No Pretns Found."
              columns={columns} manual data={data}
              pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
        </div>

      </div>
    </div>

    </div>
  }
}


export default Pretns;



// WEBPACK FOOTER //
// ./src/components/debit/debitlist.js